import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { connect } from 'react-redux';
import { HIDE_CONFIRM_CLEAR_ARRAYS_MODAL } from 'actions';
import { state } from '__common/store';
import { disabled722BuildingCodeProducts } from '__common/constants/products';
import { asce_722 } from '__common/constants/buildingCodes';
import { ACCESS_FOR_7_22_PERMISSION } from 'user/userGroups';
import { applyAsce722AccessForEcoFoot2Plus, applyAsce722AccessForRM10Evo } from '__common/utils/versionCompare/versionCompare';

type Props = {
  dispatch: Function,
  isOpen: boolean,
  onCancelAction?: any,
  onConfirmAction: any,
  onConfirmCallback: Function,
  onCancelCallback: Function,
  mapType: string,
  title: string,
  content: string,
  confirmTitle: string,
  cancelTitle: string,
  dialogStyleProps: Object,
  modal: boolean,
};

class ConfirmClearArraysModal extends React.Component<Props, {}> {
  hide = () => {
    const { dispatch } = this.props;
    dispatch(HIDE_CONFIRM_CLEAR_ARRAYS_MODAL());
  }

  cancel = () => {
    const { dispatch, onCancelAction, onCancelCallback } = this.props;
    if (onCancelAction) {
      dispatch(onCancelAction);
    }
    if (onCancelCallback) {
      onCancelCallback();
    }
    this.hide();
  }

  onContinue = () => {
    const { onConfirmAction, dispatch, onConfirmCallback } = this.props;

    this.hide();

    if (onConfirmAction) {
      dispatch(onConfirmAction);
    }

    if (onConfirmCallback) {
      onConfirmCallback();
    }
  }

  render() {
    const {
      isOpen,
      title,
      content,
      confirmTitle,
      cancelTitle,
      dialogStyleProps,
      modal,
      onCancelAction,
      onCancelCallback,
    } = this.props;
    const { projectConfiguration: { projectEnvConfig: { helioscope_id, building_code }, productId, projectVersion }, user: { permissions } } = state();
    const is722LimitedAccess = !applyAsce722AccessForRM10Evo(productId, projectVersion) && !applyAsce722AccessForEcoFoot2Plus(productId, projectVersion);

    const showCancelButton = !(helioscope_id && !title)
      && (Boolean(cancelTitle || onCancelAction || onCancelCallback) ||
        (is722LimitedAccess && !permissions.includes(ACCESS_FOR_7_22_PERMISSION) && disabled722BuildingCodeProducts(productId) && building_code !== asce_722.value));

    return (
      <Dialog
        {...dialogStyleProps}
        id="arrays-lost-modal"
        className="confirm-clear-arrays-modal"
        open={isOpen}
        onClose={this.cancel}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          elevation: 2,
          className: 'confirm-clear-arrays-paper',
        }}
      >
        {title && (
          <DialogTitle className="confirm-clear-arrays-title">
            {title}
          </DialogTitle>
        )}

        {content && (
          <DialogContent className="confirm-clear-arrays-content">
            {content}
          </DialogContent>
        )}

        <DialogActions className="confirm-clear-arrays-actions">
          {showCancelButton && (
            <Button
              variant="text"
              className="cancel-button"
              onClick={this.cancel}
            >
              {cancelTitle || 'NO, CANCEL'}
            </Button>
          )}
          <Button
            variant="text"
            className="submit-button"
            onClick={this.onContinue}
          >
            {confirmTitle || 'YES, CONTINUE'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

function mapStateToProps(appState: appState) {
  return {
    isOpen: appState.confirmClearArraysModal.isOpen,
    onCancelAction: appState.confirmClearArraysModal.onCancelAction,
    onConfirmAction: appState.confirmClearArraysModal.onConfirmAction,
    onConfirmCallback: appState.confirmClearArraysModal.onConfirmCallback,
    onCancelCallback: appState.confirmClearArraysModal.onCancelCallback,
    title: appState.confirmClearArraysModal.title,
    confirmTitle: appState.confirmClearArraysModal.confirmTitle,
    cancelTitle: appState.confirmClearArraysModal.cancelTitle,
    dialogStyleProps: appState.confirmClearArraysModal.dialogStyleProps,
    content: appState.confirmClearArraysModal.content,
    mapType: appState.roofsSelector.mapType,
    roofs: appState.drawingManager.roofs,
    modal: appState.confirmClearArraysModal.modal,
  };
}

export default connect(mapStateToProps)(ConfirmClearArraysModal);
